import { useCallback, useRef } from 'react';

interface UseSoundOptions {
  volume?: number;
  playbackRate?: number;
  interrupt?: boolean;
}

export const useSound = (
  soundPath: string,
  { volume = 1.0, playbackRate = 1.0, interrupt = true }: UseSoundOptions = {}
) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const play = useCallback(() => {
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio(soundPath);
      }

      const audio = audioRef.current;
      
      // If interrupt is true, stop current playback and restart
      if (interrupt) {
        audio.currentTime = 0;
      }
      
      audio.volume = volume;
      audio.playbackRate = playbackRate;
      
      // Play the sound
      const playPromise = audio.play();
      
      // Handle play promise to avoid console errors
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log('Audio play failed:', error);
        });
      }
    } catch (error) {
      console.error('Error playing sound:', error);
    }
  }, [soundPath, volume, playbackRate, interrupt]);

  const stop = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }, []);

  return { play, stop };
};